import React, { useState } from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import Logo from "../components/Logo"
import Background from "../components/Background"
import { Downloads } from "../components/Downloads"
import SEO from "../components/seo"
import { ContactForm } from "../components/ContactForm"
import styled from "styled-components"
import { useStaticQuery, graphql } from "gatsby"
import { Video } from "../components/Video"

const IndexPage = () => {
  const [errorMsg, setErrorMsg] = useState("")
  const data = useStaticQuery(graphql`
    query {
      fotoIzquierda: file(relativePath: { eq: "izquierda.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 800) {
            ...GatsbyImageSharpFluid
          }
          resize(width: 400, jpegProgressive: true) {
            src
            width
          }
        }
      }
      fotoDerecha: file(relativePath: { eq: "derecha.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 800) {
            ...GatsbyImageSharpFluid
          }
          resize(width: 400, jpegProgressive: true) {
            src
            width
          }
        }
      }
      logoImage: file(relativePath: { eq: "logo.png" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
          resize(width: 400, jpegProgressive: true) {
            src
            width
          }
        }
      }
    }
  `)
  console.log(data)
  return (
    <Layout>
      <SEO title="YAN ADROVER" />

      <Background />
      {/* <VideoFullSceeen videoId="okDruw3ct6s" titulo="LÍBERTI" /> */}

      <Section>
        <Col>
          <Inner>
            <Title>Bio</Title>
            <p>Yan Adrover es autor, compositor y productor musical. </p>
            <p>
              Su música fusiona los folklores argentinos y latinoamericanos, el
              tango, la electrónica, y la canción francesa… en el universo de
              Yan la palabra es protagonista, y la música testigo, testimonio de
              experiencias de otros planos, de otras realidades…{" "}
            </p>
            <p>
              Si bien su país de origen es la Argentina, la música de Yan está
              impregnada de cada uno de los lugaras donde vivio (La Plata,
              Buenos Aires, Ibiza, Paris, Barcelona)… entre otros.
            </p>
            <p>
              Como compositor y productor realizó música para películas,
              espectáculos de danza, y publicidades de marcas reconocidas, como
              Adidas (Buenos Aires) y Chanel (París).
            </p>
            <p>
              Su recorrido fue amplio y diverso. Tocó en prestigiosas salas y
              teatros de Europa y Latinoamérica; además de haber sido miembro
              fundador, compositor y productor de grupos como La Espiral
              Sinfónica (Ibiza), El Circo Divino (Paris-Barcelona), y Los
              Cuerpos Celestes (La Plata, Buenos Aires); formó parte de
              orquestas iraníes, griegas, catalanas y francesas, fue artista de
              circo en el Cirque de Paris y estudio y trabajo con el artista
              chileno Alejandro Jodorowsky.
            </p>
          </Inner>
        </Col>
      </Section>
      <Section>
        <Col3 background_image={data.fotoIzquierda.childImageSharp.fluid.src} />
        <ColDonacion background>
          <Inner>
            <p>
              Es gracias a tu generosidad, valoración y reconocimiento, que los
              artistas independientes podemos producir el contenido que
              ofrecemos. Cada donación que hagas volverá a ti en forma de
              canciones, vídeos y poesías, para acompañarte hoy y siempre...
              Gracias!
            </p>
            <BotonDonacion
              href="https://www.paypal.com/paypalme2/yanadrover?locale.x=es_ES"
              target="_blank"
            >
              Haz tu donación
            </BotonDonacion>
          </Inner>
        </ColDonacion>

        <Col3 background_image={data.fotoDerecha.childImageSharp.fluid.src} />
      </Section>

      <Video title="#HAY_UN_RIO" />

      <ContactForm
        title="Contacto"
        paragraph="Si quieres, puedes dejarme un mensaje y te mantendré informado."
      />
    </Layout>
  )
}

const Col = styled.div`
  width: 100%;
  float: left;
  box-sizing: border-box;
  @media (min-width: 999px) {
    justify-content: center;
    align-items: center;
    display: table-cell;
    vertical-align: middle;
    width: 100%;
    ${props => (props.inner ? "padding: 4em;" : "")}
  }
`
const Iframe = styled.iframe`
  width: 100%;
`
const Col2 = styled.div`
  width: 100%;
  float: left;
  box-sizing: border-box;
  @media (min-width: 999px) {
    justify-content: center;
    align-items: center;
    display: table-cell;
    vertical-align: middle;
    width: 50%;
    ${props => (props.inner ? "padding: 4em;" : "")}
  }
`

const Inner = styled.div`
  padding: 4em;
`
const Section = styled.section`
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
  line-height: 1.88;
  font-weight: 400;
  z-index: 0;
  position: relative;
  overflow: hidden;
  background-attachment: scroll;
  background-repeat: no-repeat;
  background-position: center center;
  width: 100%;
  width: calc(100% + 2px);
  margin-left: -1px;
  margin-right: -1px;
  margin-top: -1px;
  @media (min-width: 999px) {
    /* height: 600px; */
  }
`

const Col3 = styled.div`
  ${props =>
    props.background_image
      ? `background-image: url(${props.background_image});`
      : ""}

  height: 400px;
  width: 100%;
  float: left;
  box-sizing: border-box;
  ${props => (props.background ? "background: #1a1a1a; color: #FFFFFF;" : "")}
  @media (min-width: 999px) {
    justify-content: center;
    align-items: center;
    display: table-cell;
    vertical-align: middle;
    width: 33.33%;
    ${props => (props.inner ? "padding: 4em;" : "")}
  }
`
const ColDonacion = styled.div`
  ${props =>
    props.background_image
      ? `background-image: url(${props.background_image});`
      : ""}

  width: 100%;
  float: left;
  box-sizing: border-box;
  ${props => (props.background ? "background: #1a1a1a; color: #FFFFFF;" : "")}
  @media (min-width: 999px) {
    justify-content: center;
    align-items: center;
    display: table-cell;
    vertical-align: middle;
    width: 33.33%;
    ${props => (props.inner ? "padding: 4em;" : "")}
    height: 400px;
  }
`

const Title = styled.h2`
  font-family: Oswald, sans-serif !important;
`
const BotonDonacion = styled.a`
  background: #ffffff;
  text-decoration: none;
  cursor: pointer;
  padding: 10px 15px;
  border-color: #ffffff;
  border-radius: 3px;
  color: #000;
  display: block;
  width: 100%;
  text-align: center;
  &[disabled] {
    opacity: 0.3;
  }
`
export default IndexPage
